module.exports = __webpack_public_path__ + "img/top-10-map-view.c0a28287.jpg";